"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USE_CLASSES = exports.INPUT_SIZE_OPTIONS = void 0;
var INPUT_SIZE_OPTIONS = {
  default: '',
  small: 'private-form__control--small'
};
exports.INPUT_SIZE_OPTIONS = INPUT_SIZE_OPTIONS;
var USE_CLASSES = {
  default: '',
  'on-dark': 'private-form__control--on-dark'
};
exports.USE_CLASSES = USE_CLASSES;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/input/InputConstants.js
// module id = 251
// module chunks = 209 210 211 212